<div *ngIf="showProvisioning" class="auth-callback d-flex align-items-center justify-content-center">
  <div class="auth-callback-content text-center text-white">
    <div class="auth-callback-logo mx-auto mb-4"></div>
    <h2 class="auth-callback-heading">We're provisioning your CloudRadial Chat account.</h2>
    <p class="auth-callback-body">
      Thank you for signing up. You're minutes away from offering your clients live chat support.
    </p>
  </div>
</div>
